export enum ProductWidgets {
  FastagRecharge = 'FASTAG_RECHARGE',
  Challan = 'CHALLAN',
  BuyFastag = 'BUY_FASTAG',
  BankListInterlinking = 'BANK_LIST_INTERLINKING',
  InsuranceHighlights = 'INSURANCE_HIGHLIGHTS',
  InsurerList = 'INSURER_LIST',
  RTOListInterlinking = 'RTO_LIST_INTERLINKING',
  RTOOfficeListInterlinking = 'RTO_OFFICE_LIST_INTERLINKING',
  InsuranceAddons = 'INSURANCE_ADDONS',
  EmiCalculator = 'EMI_CALCULATOR',
  FuelPrices = 'FUEL_PRICES',
  CitiesFuelPrice = 'CITIES_FUEL_PRICE',
  FuelPricTable = 'FUEL_PRICE_TABLE',
  FuelPriceStateList = 'FUEL_PRICES_STATE_LIST',
  FuelPriceStateFuelTable = 'FUEL_PRICES_STATE_FUEL_TABLE',
  DrivingLicenseQuiz = 'DRIVING_LICENSE_QUIZ',
  RewardWidget = 'REWARD_WIDGET',
}
